export default "__VITE_ASSET__ClAux6gA__"